import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTillToWidth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 90,
	viewBox: "0 0 200 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3004_29247",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 200,
		height: 90,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 90,
			fill: "#C4C4C4"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_3004_29247)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M103.39 43.6116L114.068 43.6116L111.703 41.0498C111.541 40.874 111.449 40.6356 111.449 40.387C111.449 40.1383 111.541 39.8999 111.703 39.7241L112.316 39.06C112.396 38.9726 112.492 38.9033 112.597 38.8559C112.702 38.8086 112.815 38.7843 112.929 38.7843C113.043 38.7843 113.156 38.8086 113.261 38.8559C113.366 38.9033 113.461 38.9726 113.542 39.06L118.426 44.3549C118.589 44.5307 118.68 44.7692 118.68 45.0178C118.68 45.2664 118.589 45.5049 118.426 45.6807L113.539 50.9752C113.459 51.0626 113.363 51.132 113.258 51.1793C113.153 51.2266 113.04 51.251 112.926 51.251C112.812 51.251 112.699 51.2266 112.594 51.1793C112.489 51.132 112.393 51.0626 112.313 50.9752L111.7 50.3112C111.538 50.1354 111.447 49.8969 111.447 49.6483C111.447 49.3997 111.538 49.1612 111.7 48.9854L114.065 46.4241L103.39 46.4241C103.161 46.4241 102.941 46.3253 102.778 46.1495C102.616 45.9737 102.525 45.7352 102.525 45.4866L102.525 44.5491C102.525 44.3004 102.616 44.062 102.778 43.8862C102.941 43.7103 103.161 43.6116 103.39 43.6116Z",
				fill: "#F6DCC4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M84.8538 50.6063L84.8542 32.5323L34.8107 60.6969L34.8103 78.771L84.8538 50.6063Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.8097 60.6967L8.37994 46.3885L8.37919 64.5355L34.809 78.8437L34.8097 60.6967Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85.0731 32.3407L58.7927 18.1136L8.53433 46.4693L34.8147 60.6964L85.0731 32.3407Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M189.727 77.1819L174.075 86.2193L173.444 28.7981L189.096 19.7607L189.727 77.1819Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M173.444 28.7974L147.837 13.0627L163.553 3.98853L189.159 19.7233L173.444 28.7974Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M174.019 86.5046L148.558 70.8588L147.985 13.1559L173.446 28.8017L174.019 86.5046Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
export default SvgTillToWidth;
